'use strict';

const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./storeLocator/storeLocator'));
    processInclude(require('./components/rolex/storeLocator'));
});
